import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';
import { CompInfoDependency } from '@wix/thunderbolt-components-native';
import {
  SoundCloudWidgetCSSVars,
  SoundCloudWidgetDefinition,
  SoundCloudWidgetProps,
} from '../SoundCloudWidget.types';
import {
  props as viewerPropsMapper,
  css as viewerCssMapper,
} from './SoundCloudWidget.mapper';

const viewerDeps = Object.keys(viewerPropsMapper.deps) as Array<
  CompInfoDependency
>;

const props = withCompPreviewProps<
  SoundCloudWidgetProps,
  SoundCloudWidgetDefinition
>()(
  ['isPlayingAllowed', 'shouldResetComponent', ...viewerDeps],
  (deps, carmiData) => {
    const viewerProps = viewerPropsMapper.resolver(deps, carmiData);

    return {
      ...viewerProps,
      autoPlay: deps.isPlayingAllowed && viewerProps.autoPlay,
      previewWrapperProps: {
        shouldResetComponent: deps.shouldResetComponent,
      },
    };
  },
);

export const css = withCompPreviewInfo<
  SoundCloudWidgetCSSVars,
  SoundCloudWidgetDefinition
>()([...viewerDeps], (deps, carmiData) => {
  const viewerCss = viewerCssMapper.resolver(deps, carmiData);
  return viewerCss;
});

export default createComponentPreviewMapperModel({
  props: props as any,
  css: css as any,
});
